import { render, staticRenderFns } from "./ActivityFeed.vue?vue&type=template&id=50f82ef9&scoped=true&"
import script from "./ActivityFeed.vue?vue&type=script&lang=js&"
export * from "./ActivityFeed.vue?vue&type=script&lang=js&"
import style0 from "./ActivityFeed.vue?vue&type=style&index=0&id=50f82ef9&lang=scss&scoped=true&"
import style1 from "./ActivityFeed.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f82ef9",
  null
  
)

export default component.exports